import './CallbackMessage.scss'
import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export interface CallbackMessageProps {
  /** Native BroadcastChannel to post the email address on (a plain string). */
  channel: string
  success: (email: string) => string
  missing: string
}

/**
 * An OAuth popup's landing page: reads `?emailaddress=`, posts it once on
 * the channel the opener listens to (the opener closes the popup), and says
 * what happened. Public, no shell.
 */
export function CallbackMessage({ channel, success, missing }: CallbackMessageProps) {
  const [params] = useSearchParams()
  const email = params.get('emailaddress')
  // Posted once per address, also under StrictMode's double effect.
  const postedEmail = useRef<string | null>(null)

  useEffect(() => {
    if (!email || postedEmail.current === email) return
    postedEmail.current = email
    const broadcast = new BroadcastChannel(channel)
    broadcast.postMessage(email)
    return () => {
      broadcast.close()
    }
  }, [channel, email])

  // Derived from the URL, so it renders at once: the portal's 'Loading..'
  // only lasted until its effect ran.
  const message = email ? success(email) : missing
  return (
    <main className="callback-message">
      <p className="callback-message__text" role="status">
        {message}
      </p>
    </main>
  )
}
